<div
  class="tw-bg-black container-fluid tw-relative tw-min-h-[500px] tw-overflow-hidden"
>
  <!-- Imagen de fondo con degradados -->
  <img
    src="assets/elipsis/orange.svg"
    alt=""
    class="tw-absolute tw-right-[0px] tw-top-[-5px] lg:tw-top-[-10px] lg:tw-right-[10px] tw-opacity-35 tw-blur-md"
  />
  <img
    src="assets/elipsis/blue.svg"
    alt=""
    class="tw-absolute tw-top-[-5px] tw-right-[0px] lg:tw-top-[-10px] lg:right-[10px] tw-opacity-35 tw-blur-md"
  />

  <!-- Contenido -->
  <div class="tw-relative tw-z-10 tw-max-w-5xl tw-mx-auto tw-px-4">
    <h2
      class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight"
    >
      <span class="tw-text-white"> Calificaciones y Opiniones</span>
    </h2>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let item of data">
          <app-review
            [name]="item.name"
            [text]="item.text"
            [photo]="item.img"
            [rating]="item.rating"
          ></app-review>
        </div>
      </div>

    
    </div>
  </div>
</div>
